// TSS vite/03 §"Query keys".

export const embryoKeys = {
    all: ['embryos'],
    list: (filters) => ['embryos', 'list', filters],
    infinite: (filters, limit) => ['embryos', 'list', 'infinite', filters, limit],
    detail: (id) => ['embryos', 'detail', id],
    available: (filters) => ['embryos', 'available', filters],
};
